import { Theme } from '@mui/material/styles';
import { Colors, Cards } from '../../../assets/styles';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme: Theme) => {
  const pxToRem = (px: number): string => `${px / 16}rem`;

  return {
    container: {
      padding: `${pxToRem(48)} ${pxToRem(140)} ${pxToRem(140)} ${pxToRem(140)}`,
    },
    title: {
      textAlign: 'center',
       marginBottom: '24px !important',
    },
    sideNav: {
      backgroundColor: Colors.Gray8,
      borderTopRightRadius: 0,
      borderBottomRightRadius: 0,
      ...Cards.CardShadow2,
      padding: `${pxToRem(35)} ${pxToRem(30)}`,
    },
    main: {
      backgroundColor: Colors.White,
      borderTopLeftRadius: 0,
      borderBottomLeftRadius: 0,
      ...Cards.CardShadow2,
      padding: `${pxToRem(35)} ${pxToRem(40)}`,
    },
  };
});

export default useStyles;
